(function (global) {

  // Data to Page function 
  var pages_data = {
    'home': {
      'type': 'Home Page',
      'name': 'Index'
    },
    'como-funciona': {
      'type': 'How It Works Page',
      'name': 'How It Works'
    },
    'todos': {
      'type': 'Packs Page',
      'name': 'Packs'
    },
    'search': {
      'type': 'Search Page',
      'name': 'Search'
    },
    'terminos-y-condiciones': {
      'type': 'Terms and Conditions Page',
      'name': 'Terms and Conditions'
    },
    'politica-de-privacidad': {
      'type': 'Privacy Policy Page',
      'name': 'Privacy Policy'
    }
  }

  function page(handle) {

    let type = (handle in pages_data) ? pages_data[handle].type : null;
    let name = (handle in pages_data) ? pages_data[handle].name : null;

    dataLayer.push({
      'page': {
        'type': type,
        'name': name
      }
    });
  }

  function user(customer_id) {
    dataLayer.push({
      'user': {
        'id': customer_id
      }
    });
  }


  function quantityClick(product) {
    dataLayer.push({
      'event': 'quantityClick',
      'currencyCode': 'ARS',
      'actionField': {
        'list': 'Change pack size'
      },
      'ecommerce': {
        'click': {
          'products': [{
            'id': product.id,
            'name': product.name,
            'brand': product.brand,
            'list': product.list,
            'category': product.category,
            'variant': product.variant,
            'price': parseInt(product.price / 100).toFixed(2),
            'metric1': product.metric1,
            'position': product.position
          }]
        }
      }
    });
  }

  global.dataLayerGtm = {
    page,
    pages_data,
    user,
    quantityClick
  }

})(window)